import { css } from 'lit';
import { styles as baseStyles } from '@triptease/stylesheet/lit';

export const styles = [
  baseStyles,
  css`
    :host {
      display: block;
    }

    .pagination-row {
      display: flex;
      justify-content: flex-end;
      padding-top: var(--space-scale-1);
    }
  `,
];
